/* Aversa Fit — interações do tema */
(function () {
  'use strict';

  var money = function (cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var norm = function (s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  };

  /* ---------- Revelar ao rolar ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('reveal-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('reveal-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Menu do celular ---------- */
  function initMenu() {
    var btn = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { nav.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); });
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = document.querySelector('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-show'); }, 2600);
  }

  /* ---------- Sacola (gaveta) ---------- */
  var drawer = document.querySelector('[data-drawer]');
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }
  function renderDrawer(cart) {
    var body = document.querySelector('[data-drawer-body]');
    var foot = document.querySelector('[data-drawer-foot]');
    if (!body) return;
    setCount(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = '<div class="drawer__empty"><p>Sacola vazia</p><p>Escolha suas peças na coleção.</p></div>';
      foot.setAttribute('hidden', '');
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cart-line__variant">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="cart-line" data-key="' + esc(it.key) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span></span>') +
        '<div><a class="cart-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<div class="qty" style="margin-top:.5rem"><button type="button" data-line-qty="-1" aria-label="Diminuir">−</button>' +
        '<input type="number" value="' + it.quantity + '" min="0" aria-label="Quantidade" data-line-input>' +
        '<button type="button" data-line-qty="1" aria-label="Aumentar">+</button></div>' +
        '<button type="button" class="cart-line__remove" data-line-remove>Remover</button></div>' +
        '<div class="cart-line__price">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    document.querySelector('[data-drawer-total]').textContent = money(cart.total_price);
    foot.removeAttribute('hidden');
  }
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function openDrawer() {
    if (!drawer) return;
    document.body.classList.add('drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    fetchCart().then(renderDrawer);
  }
  function closeDrawer() {
    document.body.classList.remove('drawer-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderDrawer(cart);
      if (document.body.classList.contains('template-cart')) location.reload();
    });
  }
  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Não foi possível adicionar.');
        return data;
      });
    });
  }

  function initDrawer() {
    document.querySelectorAll('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!drawer || document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        openDrawer();
      });
    });
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    document.addEventListener('click', function (e) {
      var line = e.target.closest('.cart-line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var input = line.querySelector('[data-line-input]');
      var step = e.target.closest('[data-line-qty]');
      if (step) changeLine(key, Number(input.value) + Number(step.getAttribute('data-line-qty')));
      if (e.target.closest('[data-line-remove]')) changeLine(key, 0);
    });
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-line-input]')) return;
      var line = e.target.closest('.cart-line');
      changeLine(line.getAttribute('data-key'), Number(e.target.value));
    });

    /* Adição rápida nos cards */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      addToCart(btn.getAttribute('data-quick-add'), 1)
        .then(function () { toast('Adicionado à sacola: ' + btn.getAttribute('data-title')); openDrawer(); })
        .catch(function (err) { toast(err.message); })
        .finally(function () { btn.disabled = false; });
    });

    /* Você também pode gostar: o select escolhe a variante do botão */
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-rel-variant]')) return;
      var btn = e.target.closest('.rel-card').querySelector('[data-quick-add]');
      btn.setAttribute('data-quick-add', e.target.value);
    });
  }

  /* ---------- Página de produto ---------- */
  function initProduct() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;
    var data;
    try { data = JSON.parse(section.querySelector('[data-product-json]').textContent); } catch (e) { return; }

    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-btn]');
    var msg = section.querySelector('[data-form-msg]');
    var priceEl = section.querySelector('[data-price-current]');
    var mainImg = section.querySelector('[data-gallery-main] img');
    var mainBox = section.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-thumb]'));

    function setMain(src, alt) {
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
      mainImg.alt = alt || '';
      mainBox.classList.remove('is-zoomed');
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        setMain(t.getAttribute('data-full'), t.getAttribute('data-alt'));
      });
    });
    /* No celular não tem zoom na foto: arrasta para o lado para trocar (como na Armfit) */
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    function stepPhoto(dir) {
      var visible = thumbs.filter(function (t) { return !t.hidden; });
      if (visible.length < 2) return;
      var cur = visible.findIndex(function (t) { return t.classList.contains('is-active'); });
      var next = visible[(Math.max(cur, 0) + dir + visible.length) % visible.length];
      next.click();
      next.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    if (mainBox) {
      var startX = null, startY = null;
      mainBox.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { startX = null; return; }
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      }, { passive: true });
      mainBox.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) stepPhoto(dx < 0 ? 1 : -1);
      });
      mainBox.addEventListener('click', function (e) {
        if (!canHover) return;
        var zoomed = mainBox.classList.toggle('is-zoomed');
        if (zoomed && mainImg) {
          var r = mainBox.getBoundingClientRect();
          mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        }
      });
    }

    /* Galeria por cor: a cor de cada foto vem do texto alternativo ("Produto Azul — arquivo.jpg") */
    function filterByColor(color) {
      if (!thumbs.length || !color) return;
      var c = norm(color);
      var matches = thumbs.filter(function (t) { return norm(t.getAttribute('data-alt')).indexOf(c) !== -1; });
      if (!matches.length) { thumbs.forEach(function (t) { t.hidden = false; }); return; }
      thumbs.forEach(function (t) { t.hidden = matches.indexOf(t) === -1; t.classList.remove('is-active'); });
      matches[0].classList.add('is-active');
      setMain(matches[0].getAttribute('data-full'), matches[0].getAttribute('data-alt'));
    }

    function selectedOptions() {
      var opts = [];
      section.querySelectorAll('[data-option-index]:checked').forEach(function (i) {
        opts[Number(i.getAttribute('data-option-index'))] = i.value;
      });
      return opts;
    }
    function findVariant(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      });
    }
    function markAvailability(opts) {
      section.querySelectorAll('[data-option-index]').forEach(function (input) {
        var idx = Number(input.getAttribute('data-option-index'));
        var test = opts.slice();
        test[idx] = input.value;
        var v = findVariant(test);
        var chip = input.nextElementSibling;
        if (chip) chip.classList.toggle('is-unavailable', !v || !v.available);
      });
    }
    function update(changedIndex) {
      var opts = selectedOptions();
      var v = findVariant(opts);
      opts.forEach(function (val, i) {
        var label = section.querySelector('[data-option-label="' + i + '"]');
        if (label) label.textContent = val;
      });
      markAvailability(opts);
      msg.textContent = '';
      msg.classList.remove('is-error');
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = 'Indisponível';
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = v.price;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Adicionar à sacola' : 'Esgotado';
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (data.colorIndex !== null && (changedIndex === undefined || changedIndex === data.colorIndex)) {
        filterByColor(opts[data.colorIndex]);
      }
    }

    section.querySelectorAll('[data-option-index]').forEach(function (input) {
      input.addEventListener('change', function () { update(Number(input.getAttribute('data-option-index'))); });
    });

    /* Abre na cor da primeira foto (ex.: Azul), se a URL não pedir uma variante */
    if (data.colorIndex !== null && !/[?&]variant=/.test(location.search) && thumbs.length) {
      var firstAlt = norm(thumbs[0].getAttribute('data-alt'));
      var colorInputs = section.querySelectorAll('[data-option-index="' + data.colorIndex + '"]');
      var pick = Array.prototype.find.call(colorInputs, function (i) { return firstAlt.indexOf(norm(i.value)) !== -1; });
      if (pick) pick.checked = true;
    }
    update();

    var qty = section.querySelector('[data-qty]');
    section.querySelector('[data-qty-minus]').addEventListener('click', function () { qty.value = Math.max(1, Number(qty.value) - 1); });
    section.querySelector('[data-qty-plus]').addEventListener('click', function () { qty.value = Number(qty.value) + 1; });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addBtn.disabled = true;
      addToCart(idInput.value, Math.max(1, Number(qty.value)))
        .then(function () { openDrawer(); })
        .catch(function (err) { msg.textContent = err.message; msg.classList.add('is-error'); })
        .finally(function () { addBtn.disabled = false; });
    });
  }

  /* Vindo da página /avaliar (link com #avaliar): rola até as avaliações e abre o formulário do Judge.me */
  /* Formulário do Judge.me: e-mail da conta preenchido sozinho e nome "com o meu nome" ou "anônima" */
  function initFormAvaliacao() {
    var box = document.querySelector('.reviews[data-logado]');
    if (!box) return;
    /* conta sem nome vira "Customer" no Judge.me: nesse caso o campo fica vazio pra pessoa escrever o nome */
    function nomeDeVerdade(v) {
      v = (v || '').trim();
      return v && !/^(customer|cliente)$/i.test(v) && v.indexOf('@') === -1 ? v : '';
    }
    function limparNome(campo) {
      if (!campo || campo.getAttribute('data-nome-ok')) return;
      campo.setAttribute('data-nome-ok', '1');
      var v = nomeDeVerdade(campo.value) || nomeDeVerdade(box.dataset.nome);
      if (campo.value !== v) {
        campo.value = v;
        campo.dispatchEvent(new Event('input', { bubbles: true }));
      }
      campo.readOnly = false;
      campo.placeholder = 'Como você quer aparecer (ex.: Ana S.)';
    }
    function ajustar(form) {
      if (box.dataset.logado !== 'true' || form.getAttribute('data-ajustado')) return;
      /* aviso "Como usamos seus dados" e outros blocos sem campo: some */
      form.querySelectorAll('.jdgm-form__fieldset').forEach(function (f) {
        if (!f.querySelector('input, textarea, select, button')) f.style.display = 'none';
      });
      var nome = form.querySelector('input[name="reviewer_name"]');
      var formato = form.querySelector('select[name="reviewer_name_format"]');
      var email = form.querySelector('input[name="reviewer_email"]');
      if (!nome || !formato) return;
      form.setAttribute('data-ajustado', '1');
      function setar(campo, valor) {
        campo.value = valor;
        campo.dispatchEvent(new Event('input', { bubbles: true }));
        campo.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (email && !email.value && box.dataset.email) setar(email, box.dataset.email);
      limparNome(nome);
      var campo = nome.closest('.jdgm-form__fieldset');
      var opcoes = document.createElement('div');
      opcoes.className = 'rev-nome';
      opcoes.innerHTML = '<button type="button" data-formato="" class="is-on">Com o meu nome</button><button type="button" data-formato="anonymous">Anônima</button>';
      campo.insertBefore(opcoes, nome);
      var ultimoNome = nome.value;
      opcoes.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        var anonima = b.dataset.formato === 'anonymous';
        opcoes.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        campo.classList.toggle('is-anonima', anonima);
        setar(formato, b.dataset.formato);
        if (anonima) {
          ultimoNome = nome.value;
          if (!nome.value) setar(nome, nomeDeVerdade(box.dataset.nome) || 'Anônima');  /* o Judge.me exige o nome, mas mostra "Anônimo" */
        } else if (ultimoNome) {
          setar(nome, ultimoNome);
        }
      });
    }
    new MutationObserver(function () {
      box.querySelectorAll('.jdgm-form').forEach(ajustar);
      /* janela de avaliação do Judge.me (abre fora da seção, pra quem está logada) */
      if (box.dataset.logado === 'true') limparNome(document.querySelector('#jdgm-name-input'));
    }).observe(document.body, { childList: true, subtree: true });
    box.querySelectorAll('.jdgm-form').forEach(ajustar);
  }

  /* O nome da avaliação tem que ser o que a pessoa digitou. Quando recebe o id da conta, o servidor do Judge.me
     troca o nome digitado pelo nome da conta ("Customer" se a conta não tem nome). Por isso o id não é enviado. */
  function initNomeDigitado() {
    if (!document.querySelector('.reviews[data-logado]')) return;
    var abrir = XMLHttpRequest.prototype.open;
    var enviar = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (metodo, url) {
      this._aversaAvaliacao = /\/reviews(\?|$)|\/update_review/.test(String(url)) && /judge\.?me/i.test(String(url));
      return abrir.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (corpo) {
      if (this._aversaAvaliacao) {
        if (typeof FormData !== 'undefined' && corpo instanceof FormData) {
          corpo.delete('shopify_customer_id');
        } else if (typeof corpo === 'string') {
          var campos = new URLSearchParams(corpo);
          campos.delete('shopify_customer_id');
          arguments[0] = campos.toString();
        }
      }
      return enviar.apply(this, arguments);
    };
  }

  /* Avaliações publicadas: anônima aparece como "Anônima". "Customer" só existe em avaliação antiga, feita antes
     de o nome digitado valer (corrigir o nome dela no Judge.me).
     Nome fica "Primeiro S." com maiúscula certa, e a data vai pro formato brasileiro */
  function initNomesAvaliacoes() {
    var anonimos = /^(anonymous|an[oô]nimo|an[oô]nima)$/i;
    var genericos = /^(customer|cliente)$/i;
    function maiuscula(p) { return p.charAt(0).toLocaleUpperCase('pt-BR') + p.slice(1).toLocaleLowerCase('pt-BR'); }
    function normalizar(nome) {
      nome = (nome || '').replace(/\s+/g, ' ').trim();
      if (anonimos.test(nome)) return 'Anônima';
      if (!nome || genericos.test(nome) || nome.indexOf('@') !== -1) return 'Cliente Aversa';
      var partes = nome.split(' ');
      var primeiro = maiuscula(partes[0]);
      if (partes.length < 2) return primeiro;
      var ultimo = partes[partes.length - 1].replace(/\.$/, '');
      return primeiro + ' ' + ultimo.charAt(0).toLocaleUpperCase('pt-BR') + '.';
    }
    function ajustar() {
      document.querySelectorAll('.jdgm-rev__author:not([data-nome-ok])').forEach(function (el) {
        el.setAttribute('data-nome-ok', '1');
        var novo = normalizar(el.textContent);
        if (el.textContent !== novo) el.textContent = novo;
      });
      document.querySelectorAll('.jdgm-rev__timestamp:not([data-data-ok])').forEach(function (el) {
        var m = (el.textContent || '').trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        if (!m) return;  /* o Judge.me preenche a data depois: tenta de novo na próxima mudança */
        el.setAttribute('data-data-ok', '1');
        el.textContent = ('0' + m[2]).slice(-2) + '/' + ('0' + m[1]).slice(-2) + '/' + m[3];
      });
    }
    if (!document.querySelector('.jdgm-widget, .reviews')) return;
    new MutationObserver(ajustar).observe(document.body, { childList: true, subtree: true, characterData: true });
    ajustar();
  }

  function initAvaliar() {
    if (location.hash !== '#avaliar') return;
    var tries = 0;
    var timer = setInterval(function () {
      var link = document.querySelector('.jdgm-write-rev-link');
      if (link || ++tries > 40) {
        clearInterval(timer);
        if (!link) return;
        var widget = document.querySelector('.jdgm-widget') || link;
        widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        /* O Judge.me liga o clique só depois de montar o widget: tenta abrir algumas vezes */
        var opens = 0;
        var opener = setInterval(function () {
          var form = document.querySelector('.jdgm-form-wrapper');
          var visible = form && form.offsetParent !== null && form.offsetHeight > 0;
          if (visible) {
            clearInterval(opener);
            setTimeout(function () { form.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 200);
            return;
          }
          if (++opens > 8) { clearInterval(opener); return; }
          link.click();
        }, 700);
      }
    }, 250);
  }

  /* ---------- Acordeão do produto: separa "Composição e cuidados" da descrição ---------- */
  function initAccordion() {
    var desc = document.querySelector('[data-desc]');
    var care = document.querySelector('[data-care]');
    if (!desc || !care) return;
    var heading = Array.prototype.find.call(desc.querySelectorAll('h1, h2, h3, h4, h5, h6, p'), function (el) {
      var t = norm(el.textContent).trim();
      return /^composicao/.test(t) || /^cuidados/.test(t);
    });
    if (!heading) return;
    /* o título pode estar dentro de outro elemento; sobe até ser filho direto da descrição */
    while (heading.parentNode !== desc) heading = heading.parentNode;
    var body = care.querySelector('[data-care-body]');
    var node = heading.nextSibling;
    while (node) {
      var next = node.nextSibling;
      body.appendChild(node);
      node = next;
    }
    heading.remove();
    if (body.textContent.trim()) care.hidden = false;
  }

  /* ---------- Sem zoom de pinça (o iOS ignora o user-scalable=no) ---------- */
  function initNoZoom() {
    ['gesturestart', 'gesturechange'].forEach(function (ev) {
      document.addEventListener(ev, function (e) { e.preventDefault(); }, { passive: false });
    });
    document.addEventListener('touchmove', function (e) {
      if (e.touches.length > 1) e.preventDefault();
    }, { passive: false });
  }
  initNoZoom();

  function initMedidas() {
    var panel = document.querySelector('[data-medidas-drawer]');
    if (!panel) return;
    function close() {
      document.body.classList.remove('medidas-open');
      panel.setAttribute('aria-hidden', 'true');
    }
    document.querySelectorAll('[data-medidas-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        document.body.classList.add('medidas-open');
        panel.setAttribute('aria-hidden', 'false');
      });
    });
    document.querySelectorAll('[data-medidas-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function initAccount() {
    var panel = document.querySelector('[data-account-drawer]');
    if (!panel) return;
    function open() {
      closeDrawer();
      document.body.classList.add('account-open');
      panel.setAttribute('aria-hidden', 'false');
    }
    function close() {
      document.body.classList.remove('account-open');
      panel.setAttribute('aria-hidden', 'true');
    }
    document.querySelectorAll('[data-account-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var nav = document.querySelector('[data-mobile-nav]');
        if (nav) nav.classList.remove('is-open');
        open();
      });
    });
    document.querySelectorAll('[data-account-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAccount();
    initMedidas();
    initAccordion();
    initAvaliar();
    initNomeDigitado();
    initFormAvaliacao();
    initNomesAvaliacoes();
    initReveal();
    initMenu();
    initDrawer();
    initProduct();
  });
})();
